import React, { useState } from 'react';
import Input from './Input';
import Button from './Button';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

const ContactForm: React.FC = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);

    try {
      const sendContactEmail = httpsCallable(functions, 'sendContactEmail');
      const result = await sendContactEmail({
        name,
        email,
        subject,
        message,
      });

      const data = result.data as { success: boolean; error?: string };

      if (data.success) {
        setSuccess(true);
        setName('');
        setEmail('');
        setSubject('');
        setMessage('');
      } else {
        setError(data.error || 'Failed to send message. Please try again.');
      }
    } catch (error: any) {
      console.error('Contact form error:', error);
      setError(error.message || 'Failed to send message. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {success && (
        <div className="bg-emerald-500/20 border border-emerald-500 text-emerald-400 px-4 py-3 rounded-lg text-sm">
          Thank you for contacting us! We&apos;ll get back to you as soon as possible.
        </div>
      )}

      {error && (
        <div className="bg-red-500/20 border border-red-500 text-red-400 px-4 py-3 rounded-lg text-sm">
          {error}
        </div>
      )}

      <Input
        type="text"
        value={name}
        onChange={e => setName(e.target.value)}
        placeholder="Your Name"
        label="* Your Name"
        required
      />

      <Input
        type="email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        placeholder="your.email@example.com"
        label="* Your Email"
        required
      />

      <Input
        type="text"
        value={subject}
        onChange={e => setSubject(e.target.value)}
        placeholder="Subject"
        label="* Subject"
        required
      />

      <div className="space-y-2">
        <label className="block text-sm font-medium text-white text-left">* Message</label>
        <textarea
          value={message}
          onChange={e => setMessage(e.target.value)}
          placeholder="Your message..."
          required
          rows={6}
          className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors duration-200 resize-none"
        />
      </div>

      <Button type="submit" disabled={loading}>
        {loading ? 'Sending...' : 'Send Message'}
      </Button>
    </form>
  );
};

export default ContactForm;
